// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminConfigsPage_root__sBhz- {
  background-color: var(--brand);
  min-height: calc(100vh - 64px);
  width: 100%;
}

.AdminConfigsPage_pageHeader__3CkHI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.28);
  margin-bottom: 16px;
}

.AdminConfigsPage_pageMain__LlRIZ {
  padding: 0 24px 32px;
}

.AdminConfigsPage_title__h4Wdm {
  font: var(--h3);
  font-weight: 700;
  color: var(--white);
  font-family: var(--font-bodoni-72);
  margin: 0;
}

.AdminConfigsPage_panelCard__yqG0N {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 24px;
  margin-top: 16px;
}

.AdminConfigsPage_panelTitle__70sun {
  font: var(--body-font-three);
  font-weight: 700;
  color: var(--primary-Text);
  margin: 0 0 12px;
}

.AdminConfigsPage_panelBody__LjDzC {
  font: var(--body-font-four);
  color: var(--secondary-Text);
  margin: 0 0 16px;
  line-height: 1.5;
}

.AdminConfigsPage_taskListKeys__T7Pvo {
  margin: 12px 0 0;
  padding-left: 20px;
  font: var(--body-font-four);
  color: var(--primary-Text);
}
.AdminConfigsPage_taskListKeys__T7Pvo li {
  margin-bottom: 4px;
}

.AdminConfigsPage_formRow__jv-tc {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: flex-end;
  margin-bottom: 16px;
}

.AdminConfigsPage_field__qVxDC {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 160px;
}

.AdminConfigsPage_fieldLabel__0Qz9l {
  font: var(--body-font-four);
  font-weight: 600;
  color: var(--primary-Text);
}

.AdminConfigsPage_errorText__QNufG {
  font: var(--body-font-four);
  color: var(--error);
  margin: 8px 0 0;
}

.AdminConfigsPage_panelHeaderRow__t763m {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}

.AdminConfigsPage_panelLink__zq6-R {
  font: var(--body-font-four);
  font-weight: 600;
  color: var(--primary-Text);
  text-decoration: underline;
}

.AdminConfigsPage_backLink__25W\\+W {
  display: inline-block;
  font: var(--body-font-four);
  color: var(--secondary-Text);
  margin-bottom: 16px;
  text-decoration: none;
}
.AdminConfigsPage_backLink__25W\\+W:hover {
  text-decoration: underline;
}

.AdminConfigsPage_configTable__WTbhK {
  width: 100%;
  border-collapse: collapse;
  font: var(--body-font-four);
  color: var(--primary-Text);
}
.AdminConfigsPage_configTable__WTbhK th,
.AdminConfigsPage_configTable__WTbhK td {
  padding: 10px 12px;
  text-align: left;
  border-bottom: 1px solid var(--border);
}
.AdminConfigsPage_configTable__WTbhK th {
  font-weight: 600;
}

.AdminConfigsPage_tableLink__qU5dc {
  color: var(--primary-Text);
  text-decoration: none;
  font-weight: 500;
}
.AdminConfigsPage_tableLink__qU5dc:hover {
  text-decoration: underline;
}

.AdminConfigsPage_taskAccordion__5egEJ {
  margin-top: 8px !important;
  box-shadow: none !important;
  border: 1px solid var(--border) !important;
  border-radius: 8px !important;
}
.AdminConfigsPage_taskAccordion__5egEJ::before {
  display: none;
}

.AdminConfigsPage_accordionSummary__4\\+ySB {
  font: var(--body-font-four);
  font-weight: 500;
}

.AdminConfigsPage_patchBadge__H6MAD {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--secondary-Text);
}

.AdminConfigsPage_configDetails__lTZsP {
  font: var(--body-font-four);
  color: var(--primary-Text);
}

.AdminConfigsPage_configDl__-D4DH {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: 4px 16px;
  margin: 0 0 16px;
}
.AdminConfigsPage_configDl__-D4DH dt {
  font-weight: 600;
}
.AdminConfigsPage_configDl__-D4DH dd {
  margin: 0;
}

.AdminConfigsPage_configSubheading__TeaWR {
  font: var(--body-font-four);
  font-weight: 700;
  margin: 12px 0 8px !important;
}

.AdminConfigsPage_configValue__dEi0- {
  margin: 0 0 8px;
  line-height: 1.5;
}

.AdminConfigsPage_configValueMuted__M5txB {
  margin: 0;
  color: var(--secondary-Text);
}

.AdminConfigsPage_riskAlertBlock__dWdAi {
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--border);
}

.AdminConfigsPage_riskLevel__kKfz6 {
  margin-bottom: 12px;
}

.AdminConfigsPage_patchBlock__F5Y2a {
  margin-top: 16px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
}

.AdminConfigsPage_patchJson__qc5V9 {
  margin: 8px 0 0;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 6px;
  font-size: 12px;
  overflow-x: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/configs/AdminConfigsPage.module.scss"],"names":[],"mappings":"AAAA;EACC,8BAAA;EACA,8BAAA;EACA,WAAA;AACD;;AAEA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,kDAAA;EACA,mBAAA;AACD;;AAEA;EACC,oBAAA;AACD;;AAEA;EACC,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,kCAAA;EACA,SAAA;AACD;;AAEA;EACC,wBAAA;EACA,+BAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AACD;;AAEA;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;EACA,gBAAA;AACD;;AAEA;EACC,2BAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;AACD;;AAEA;EACC,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,0BAAA;AACD;AACC;EACC,kBAAA;AACF;;AAGA;EACC,aAAA;EACA,eAAA;EACA,SAAA;EACA,qBAAA;EACA,mBAAA;AAAD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAAD;;AAGA;EACC,2BAAA;EACA,gBAAA;EACA,0BAAA;AAAD;;AAGA;EACC,2BAAA;EACA,mBAAA;EACA,eAAA;AAAD;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AAAD;;AAGA;EACC,2BAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;AAAD;;AAGA;EACC,qBAAA;EACA,2BAAA;EACA,4BAAA;EACA,mBAAA;EACA,qBAAA;AAAD;AAEC;EACC,0BAAA;AAAF;;AAIA;EACC,WAAA;EACA,yBAAA;EACA,2BAAA;EACA,0BAAA;AADD;AAGC;;EAEC,kBAAA;EACA,gBAAA;EACA,sCAAA;AADF;AAIC;EACC,gBAAA;AAFF;;AAMA;EACC,0BAAA;EACA,qBAAA;EACA,gBAAA;AAHD;AAKC;EACC,0BAAA;AAHF;;AAOA;EACC,0BAAA;EACA,2BAAA;EACA,0CAAA;EACA,6BAAA;AAJD;AAMC;EACC,aAAA;AAJF;;AAQA;EACC,2BAAA;EACA,gBAAA;AALD;;AAQA;EACC,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;AALD;;AAQA;EACC,2BAAA;EACA,0BAAA;AALD;;AAQA;EACC,aAAA;EACA,sCAAA;EACA,aAAA;EACA,gBAAA;AALD;AAOC;EACC,gBAAA;AALF;AAQC;EACC,SAAA;AANF;;AAUA;EACC,2BAAA;EACA,gBAAA;EACA,6BAAA;AAPD;;AAUA;EACC,eAAA;EACA,gBAAA;AAPD;;AAUA;EACC,SAAA;EACA,4BAAA;AAPD;;AAUA;EACC,eAAA;EACA,gBAAA;EACA,mCAAA;AAPD;;AAUA;EACC,mBAAA;AAPD;;AAUA;EACC,gBAAA;EACA,iBAAA;EACA,mCAAA;AAPD;;AAUA;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAPD","sourcesContent":[".root {\r\n\tbackground-color: var(--brand);\r\n\tmin-height: calc(100vh - 64px);\r\n\twidth: 100%;\r\n}\r\n\r\n.pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.28);\r\n\tmargin-bottom: 16px;\r\n}\r\n\r\n.pageMain {\r\n\tpadding: 0 24px 32px;\r\n}\r\n\r\n.title {\r\n\tfont: var(--h3);\r\n\tfont-weight: 700;\r\n\tcolor: var(--white);\r\n\tfont-family: var(--font-bodoni-72);\r\n\tmargin: 0;\r\n}\r\n\r\n.panelCard {\r\n\tbackground: var(--white);\r\n\tborder: 1px solid var(--border);\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\tmargin-top: 16px;\r\n}\r\n\r\n.panelTitle {\r\n\tfont: var(--body-font-three);\r\n\tfont-weight: 700;\r\n\tcolor: var(--primary-Text);\r\n\tmargin: 0 0 12px;\r\n}\r\n\r\n.panelBody {\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--secondary-Text);\r\n\tmargin: 0 0 16px;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.taskListKeys {\r\n\tmargin: 12px 0 0;\r\n\tpadding-left: 20px;\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--primary-Text);\r\n\r\n\tli {\r\n\t\tmargin-bottom: 4px;\r\n\t}\r\n}\r\n\r\n.formRow {\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 16px;\r\n\talign-items: flex-end;\r\n\tmargin-bottom: 16px;\r\n}\r\n\r\n.field {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 6px;\r\n\tmin-width: 160px;\r\n}\r\n\r\n.fieldLabel {\r\n\tfont: var(--body-font-four);\r\n\tfont-weight: 600;\r\n\tcolor: var(--primary-Text);\r\n}\r\n\r\n.errorText {\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--error);\r\n\tmargin: 8px 0 0;\r\n}\r\n\r\n.panelHeaderRow {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tflex-wrap: wrap;\r\n\tgap: 12px;\r\n\tmargin-bottom: 8px;\r\n}\r\n\r\n.panelLink {\r\n\tfont: var(--body-font-four);\r\n\tfont-weight: 600;\r\n\tcolor: var(--primary-Text);\r\n\ttext-decoration: underline;\r\n}\r\n\r\n.backLink {\r\n\tdisplay: inline-block;\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--secondary-Text);\r\n\tmargin-bottom: 16px;\r\n\ttext-decoration: none;\r\n\r\n\t&:hover {\r\n\t\ttext-decoration: underline;\r\n\t}\r\n}\r\n\r\n.configTable {\r\n\twidth: 100%;\r\n\tborder-collapse: collapse;\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--primary-Text);\r\n\r\n\tth,\r\n\ttd {\r\n\t\tpadding: 10px 12px;\r\n\t\ttext-align: left;\r\n\t\tborder-bottom: 1px solid var(--border);\r\n\t}\r\n\r\n\tth {\r\n\t\tfont-weight: 600;\r\n\t}\r\n}\r\n\r\n.tableLink {\r\n\tcolor: var(--primary-Text);\r\n\ttext-decoration: none;\r\n\tfont-weight: 500;\r\n\r\n\t&:hover {\r\n\t\ttext-decoration: underline;\r\n\t}\r\n}\r\n\r\n.taskAccordion {\r\n\tmargin-top: 8px !important;\r\n\tbox-shadow: none !important;\r\n\tborder: 1px solid var(--border) !important;\r\n\tborder-radius: 8px !important;\r\n\r\n\t&::before {\r\n\t\tdisplay: none;\r\n\t}\r\n}\r\n\r\n.accordionSummary {\r\n\tfont: var(--body-font-four);\r\n\tfont-weight: 500;\r\n}\r\n\r\n.patchBadge {\r\n\tmargin-left: 8px;\r\n\tfont-size: 12px;\r\n\tfont-weight: 600;\r\n\tcolor: var(--secondary-Text);\r\n}\r\n\r\n.configDetails {\r\n\tfont: var(--body-font-four);\r\n\tcolor: var(--primary-Text);\r\n}\r\n\r\n.configDl {\r\n\tdisplay: grid;\r\n\tgrid-template-columns: max-content 1fr;\r\n\tgap: 4px 16px;\r\n\tmargin: 0 0 16px;\r\n\r\n\tdt {\r\n\t\tfont-weight: 600;\r\n\t}\r\n\r\n\tdd {\r\n\t\tmargin: 0;\r\n\t}\r\n}\r\n\r\n.configSubheading {\r\n\tfont: var(--body-font-four);\r\n\tfont-weight: 700;\r\n\tmargin: 12px 0 8px !important;\r\n}\r\n\r\n.configValue {\r\n\tmargin: 0 0 8px;\r\n\tline-height: 1.5;\r\n}\r\n\r\n.configValueMuted {\r\n\tmargin: 0;\r\n\tcolor: var(--secondary-Text);\r\n}\r\n\r\n.riskAlertBlock {\r\n\tmargin-top: 8px;\r\n\tpadding-top: 8px;\r\n\tborder-top: 1px solid var(--border);\r\n}\r\n\r\n.riskLevel {\r\n\tmargin-bottom: 12px;\r\n}\r\n\r\n.patchBlock {\r\n\tmargin-top: 16px;\r\n\tpadding-top: 12px;\r\n\tborder-top: 1px solid var(--border);\r\n}\r\n\r\n.patchJson {\r\n\tmargin: 8px 0 0;\r\n\tpadding: 12px;\r\n\tbackground: #f5f5f5;\r\n\tborder-radius: 6px;\r\n\tfont-size: 12px;\r\n\toverflow-x: auto;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `AdminConfigsPage_root__sBhz-`,
	"pageHeader": `AdminConfigsPage_pageHeader__3CkHI`,
	"pageMain": `AdminConfigsPage_pageMain__LlRIZ`,
	"title": `AdminConfigsPage_title__h4Wdm`,
	"panelCard": `AdminConfigsPage_panelCard__yqG0N`,
	"panelTitle": `AdminConfigsPage_panelTitle__70sun`,
	"panelBody": `AdminConfigsPage_panelBody__LjDzC`,
	"taskListKeys": `AdminConfigsPage_taskListKeys__T7Pvo`,
	"formRow": `AdminConfigsPage_formRow__jv-tc`,
	"field": `AdminConfigsPage_field__qVxDC`,
	"fieldLabel": `AdminConfigsPage_fieldLabel__0Qz9l`,
	"errorText": `AdminConfigsPage_errorText__QNufG`,
	"panelHeaderRow": `AdminConfigsPage_panelHeaderRow__t763m`,
	"panelLink": `AdminConfigsPage_panelLink__zq6-R`,
	"backLink": `AdminConfigsPage_backLink__25W+W`,
	"configTable": `AdminConfigsPage_configTable__WTbhK`,
	"tableLink": `AdminConfigsPage_tableLink__qU5dc`,
	"taskAccordion": `AdminConfigsPage_taskAccordion__5egEJ`,
	"accordionSummary": `AdminConfigsPage_accordionSummary__4+ySB`,
	"patchBadge": `AdminConfigsPage_patchBadge__H6MAD`,
	"configDetails": `AdminConfigsPage_configDetails__lTZsP`,
	"configDl": `AdminConfigsPage_configDl__-D4DH`,
	"configSubheading": `AdminConfigsPage_configSubheading__TeaWR`,
	"configValue": `AdminConfigsPage_configValue__dEi0-`,
	"configValueMuted": `AdminConfigsPage_configValueMuted__M5txB`,
	"riskAlertBlock": `AdminConfigsPage_riskAlertBlock__dWdAi`,
	"riskLevel": `AdminConfigsPage_riskLevel__kKfz6`,
	"patchBlock": `AdminConfigsPage_patchBlock__F5Y2a`,
	"patchJson": `AdminConfigsPage_patchJson__qc5V9`
};
export default ___CSS_LOADER_EXPORT___;
